// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetFileByExternalIdRequestModel from '../../model/get-file-by-external-id-request-model';
import GetFileByExternalIdRequestDTO from '../dto/get-file-by-external-id-request-dto';
import dtoSchema from '../schemas/get-file-by-external-id-request-schema';

export default abstract class GetFileByExternalIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetFileByExternalIdRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<GetFileByExternalIdRequestDTO>): GetFileByExternalIdRequestModel;
  static toModel(dto: DeepPartial<GetFileByExternalIdRequestDTO> | undefined | null): GetFileByExternalIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetFileByExternalIdRequestDTO> | undefined | null): GetFileByExternalIdRequestModel | undefined {
    return dto ? new GetFileByExternalIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetFileByExternalIdRequestModel> | GetFileByExternalIdRequestModel): GetFileByExternalIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as GetFileByExternalIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetFileByExternalIdRequestModel, can not map to GetFileByExternalIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
